import { Alert, Box, Button, Grid } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IConfig } from '../../Interfaces/IConfig';
import { SwitchInput } from '../core/inputs/SwitchInput';
import { TwoFactorAuthInput } from '../core/inputs/TwoFactorAuthInput';
import CountdownSoftLock from './CountdownSoftLock';

interface FormValues {
  twoFactorCode: string;
  shouldSaveDevice: boolean;
}

interface IProps {
  msg: string;
  idContact: number;
  tmpSessionToken: string;
  sendFunction: Function;
  configObject: IConfig;
  softLockTime: null | string;
  setSoftLockTime: Function;
}

const defaultValues: FormValues = {
  twoFactorCode: '',
  shouldSaveDevice: false,
};

export const LoginF2A: React.FC<IProps> = ({
  msg,
  idContact,
  tmpSessionToken,
  sendFunction,
  configObject,
  softLockTime,
  setSoftLockTime,
}) => {
  const methods = useForm<FormValues>({
    defaultValues,
  });

  const handleAfterSave = (res: any) => {
    if ('detail' in res) {
      localStorage.setItem('soft_lock_till', res.detail);
      setSoftLockTime(res.detail);
    } else {
      localStorage.setItem('SessionToken', res['SessionToken']);
      localStorage.setItem(
        'TimestampSessionToken',
        res['TimestampSessionToken']
      );
      localStorage.setItem('idContact', res['idContact']);
      localStorage.setItem('role', res['Role']);
      localStorage.setItem('scope', res['Scope']);
      localStorage.setItem(
        'passwordResetRequired',
        res['passwordResetRequired']
      );

      if ('DeviceToken' in res) {
        localStorage.setItem('DeviceToken', res['DeviceToken']);
      }

      window.location.reload();
    }
  };

  const onSubmit = (data: FormValues) => {
    sendFunction(
      {
        idContact: idContact,
        TempSessionToken: tmpSessionToken,
        '2FACode': data.twoFactorCode,
        SaveDevice: data.shouldSaveDevice,
      } as any,
      handleAfterSave,
      () => methods.reset(defaultValues)
    );
  };

  return (
    <FormProvider {...methods}>
      <Box
        component='form'
        noValidate
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <Grid
          container
          spacing={0}
          direction='column'
          alignItems='center'
          justifyContent='center'
          style={{ minHeight: '100vh' }}
        >
          <img
            width={250}
            src={`data:${configObject.logo_mime};base64,${configObject.logo}`}
          />
          <Box sx={{ mt: 4 }} />
          <Grid item xs={3} style={{ width: 400 }}>
            <Box sx={{ textAlign: 'center' }}>
              Die Sicherheit Ihrer Daten ist uns sehr wichtig. Damit Ihr Konto
              optimal geschützt ist, verwenden wir eine{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                2-Faktor-Authentifizierung
              </span>
              .
              <br />
              <br />
              Hierfür wurde ein <b>Authentifizierungsschlüssel</b> per{' '}
              <span style={{ whiteSpace: 'nowrap' }}>E-Mail verschickt.</span>
              <br />
              <br />
              Bitte verlassen Sie diese Seite nicht.
              <br /> Ihr Authentifizierungsschlüssel ist eine Stunde lang
              gültig.
            </Box>
          </Grid>
          <Box sx={{ mt: 6 }} />
          <Grid item xs={3} style={{ minWidth: 350 }}>
            <TwoFactorAuthInput
              name='twoFactorCode'
              label='Authentifizierungsschlüssel'
              required
            />
          </Grid>

          <Box sx={{ mt: 3 }} />
          <Grid item xs={3} style={{ width: 350 }}>
            <Alert
              severity='info'
              action={<SwitchInput name='shouldSaveDevice' />}
            >
              <b>Gerät speichern</b>
              <br />
              Wollen Sie Ihr aktuelles Gerät speichern?
              <br />
              Gespeicherte Geräte benötigen 30 Tage keine Verifikation durch
              einen Authentifizierungsschlüssel.
            </Alert>
          </Grid>

          <Box sx={{ mt: 3 }} />
          <Grid item xs={3} style={{ minWidth: 300 }}>
            <div style={{ float: 'right' }}>
              <Button
                size='small'
                variant='contained'
                color='primary'
                type='submit'
              >
                Anmelden
              </Button>
            </div>
          </Grid>

          <Box sx={{ mt: 3 }} />
          <Grid item xs={3} style={{ minWidth: 300 }}>
            {softLockTime !== null ? (
              <CountdownSoftLock
                key={`softlock-${softLockTime}`}
                targetTime={new Date(String(softLockTime))}
              />
            ) : (
              msg !== '' && <Alert severity='error'>{msg}</Alert>
            )}
          </Grid>
        </Grid>
      </Box>
    </FormProvider>
  );
};
